import styled from 'styled-components';

const sizeMap = {
  small: '20px',
  medium: '40px',
  large: '60px',
};

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;

  p {
    margin: 0;
    color: #666;
    font-size: 0.9rem;
  }
`;

export const Spinner = styled.div`
  width: ${props => sizeMap[props.$size] || sizeMap.medium};
  height: ${props => sizeMap[props.$size] || sizeMap.medium};
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

